import { render, staticRenderFns } from "./AddressBook.vue?vue&type=template&id=6e8d915e&scoped=true"
import script from "./AddressBook.vue?vue&type=script&lang=ts"
export * from "./AddressBook.vue?vue&type=script&lang=ts"
import style0 from "./AddressBook.vue?vue&type=style&index=0&id=6e8d915e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8d915e",
  null
  
)

export default component.exports